import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, LayersControl, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import omnivore from 'leaflet-omnivore';
import { Typography, Box } from '@mui/material';

const { BaseLayer } = LayersControl;

const KmlLayer = ({ url, onError }) => {
  const map = useMap();

  useEffect(() => {
    const kmlLayer = omnivore.kml(url)
      .on('ready', () => {
        try {
          map.fitBounds(kmlLayer.getBounds());
        } catch (error) {
          console.error('Error fitting bounds:', error);
          onError('Error fitting bounds. Please check the KML file.');
        }
      })
      .on('error', (error) => {
        console.error('Error loading KML:', error);
        onError('Error loading KML file. Please check the file and try again.');
      })
      .addTo(map);

    return () => {
      map.removeLayer(kmlLayer);
    };
  }, [url, map, onError]);

  return null;
};

const KmlMap = ({ kmlUrl }) => {
  const [error, setError] = useState('');

  return (
    <Box>
      <Typography variant="h6">Project Network Map</Typography>
      {error && <Typography color="error">{error}</Typography>}
      <MapContainer center={[51.505, -0.09]} zoom={13} style={{ height: '500px', width: '100%' }}>
        <LayersControl position="topright">
          <BaseLayer checked name="OpenStreetMap">
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
          </BaseLayer>
          <BaseLayer name="Terrain">
            <TileLayer
              url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://opentopomap.org">OpenTopoMap</a> contributors'
            />
          </BaseLayer>
          <BaseLayer name="Satellite">
            <TileLayer
              url="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution="Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community"
            />
          </BaseLayer>
        </LayersControl>
        <KmlLayer url={kmlUrl} onError={setError} />
      </MapContainer>
    </Box>
  );
};

export default KmlMap;